import { render, staticRenderFns } from "./ProfilePictureDirect.vue?vue&type=template&id=db21efea&scoped=true&"
import script from "./ProfilePictureDirect.vue?vue&type=script&lang=ts&"
export * from "./ProfilePictureDirect.vue?vue&type=script&lang=ts&"
import style0 from "./ProfilePictureDirect.vue?vue&type=style&index=0&id=db21efea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db21efea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VImg})
